import { useMemo } from 'react';
import {
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { IModalReplyAdminRequest, IModalState, ModalType } from '~/shared';
import { StyledModalTitle } from './ModalTitle.styled';

const ModalTitle: React.FC<{ state: IModalState | null }> = ({
	state: state,
}: {
	state: IModalState | null;
}) => {
	const title = useMemo(
		() =>
			state?.type === ModalType.VehicleTestDrive
				? 'Подтверждение'
				: state?.title,
		[state],
	);

	return (
		<StyledModalTitle>
			<Text>{title}</Text>
			<CloseButton
				onClick={() => {
					if (state?.type === ModalType.AdminRequest) {
						const reply: IModalReplyAdminRequest = {
							isAccepted: false,
							reason: '',
							dismissedByClose: true,
						};
						rage.modal.replyToCurrentModal(reply);
					} else {
						rage.modal.replyToCurrentModal({ isAccepted: false });
					}
				}}
				height={ButtonHeight.Height20}
				color={ButtonColors.Default}
				borderRadius={ButtonBorderRadius.Radius5}
				iconSize={10}
			/>
		</StyledModalTitle>
	);
};

export { ModalTitle };
